import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './views/hompage';
import Referral from './views/referral';
import Sales from './views/sales_page';
import AboutUs from './views/AboutUs';
import Pricing from './views/Pricing';
import DeveloperDocs from './views/DeveloperDocs';
import ApiDocumentation from './views/ApiDocumentation'
import TermsService from './views/TermsService'
import PrivacyPolicy from './views/PrivacyPolicy'

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Routes WITHOUT layout */}
        <Route path="/referral" element={<Referral />} />
        <Route path="/:phone_number/:business_id" element={<Referral />} />

        {/* Routes WITH layout */}
          <Route path="/" element={<Homepage />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/developer-docs" element={<DeveloperDocs />} />
          <Route path="/ApiDocumentation" element={<ApiDocumentation />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-service" element={<TermsService />} />
          <Route path="/careers" element={<TermsService />} />
          <Route path="/sales" element={<Sales />} />
      </Routes>
    </Router>
  );
};

export default App;
